import { sessionStore } from './storage'

const KEY = 'angadi.stale_reload'
/** Don't reload again within this window: a second failure is a real error (offline, bug). */
const WINDOW_MS = 10_000

/**
 * After a deploy, a page still running the previous version (or its old service worker) asks for
 * page files that no longer exist, and the import fails. Reload once to pick up the new version
 * instead of showing "Something went wrong". Returns false when it already tried just now.
 */
export function reloadForNewVersion(now = Date.now()): boolean {
  const last = Number(sessionStore.get(KEY) ?? 0)
  if (now - last < WINDOW_MS) return false
  sessionStore.set(KEY, String(now))
  window.location.reload()
  return true
}

/** Lazy page import that survives a deploy (see `reloadForNewVersion`). */
export async function loadPage<T>(load: () => Promise<T>): Promise<T> {
  try {
    return await load()
  } catch (err) {
    if (reloadForNewVersion()) return new Promise<T>(() => undefined) // the page is reloading
    throw err
  }
}
